import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';

import { PersonOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.prefix 菜单名称前缀, 用于确定唯一名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/templateBudget',
    name: 'templateBudget',
    redirect: '/templateBudget/index',
    component: Layout,
    meta: {
      title: 'Template Budget',
      icon: renderIcon(PersonOutline),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['templateBudget_read'],
      sort: 2,
      hidden:true,
    },
   
  children: [
    {
      path: 'index',
      name: 'templateBudget',
      meta: {
        title: 'Template Budget',
        // icon: renderIcon(ApiOutlined),
        //配置该路由需要哪些权限可访问 这里是针对单个路由
        permissions: ['templateBudget_read'],
      },
      component: () => import('@/views/report/view/index.vue'),
    },
  ],
},
];

export default routes;
